export default function importHtml({ rehype, markdownFormat = {
    fences: true,
    listItemIndent: 'one',
}, } = {}) {
    const handler = async (editor, e) => {
        var _a, _b, _c;
        const items = Array.from((_c = (e instanceof ClipboardEvent
            ? (_a = e.clipboardData) === null || _a === void 0 ? void 0 : _a.items : (_b = e.dataTransfer) === null || _b === void 0 ? void 0 : _b.items)) !== null && _c !== void 0 ? _c : []);
        // fix: text copied from VSCode would have a `vscode-editor-data` type, exclude this case
        if (items.length !== 2)
            return;
        const htmlItem = items.find((item) => item.type === 'text/html');
        if (!htmlItem)
            return;
        e.preventDefault();
        let html;
        switch (htmlItem.kind) {
            case 'string': {
                html = await new Promise((resolve) => htmlItem.getAsString((v) => {
                    resolve(v);
                }));
                break;
            }
            case 'file': {
                html = await htmlItem.getAsFile().text();
                break;
            }
            default: {
                throw new Error();
            }
        }
        // console.log(html);
        const [{ default: unified }, { default: rehypeParse }, { default: rehypeRemark }, { default: remarkStringify }, { default: remarkGfm }, { toMarkdown: gfmExt },] = await Promise.all([
            import('unified'),
            import('rehype-parse'),
            // @ts-ignore
            import('rehype-remark'),
            import('remark-stringify'),
            import('remark-gfm'),
            // @ts-ignore
            import('mdast-util-gfm'),
        ]);
        let processor = unified().use(rehypeParse);
        if (rehype) {
            processor = rehype(processor);
        }
        processor = processor
            .use(rehypeRemark)
            .use(remarkGfm)
            .use(remarkStringify, {
            ...markdownFormat,
            extensions: [gfmExt()],
        });
        const result = await processor.process(html);
        editor.replaceSelection(result.toString());
    };
    return {
        editorEffect({ editor }) {
            editor.on('paste', handler);
            editor.on('drop', handler);
            return () => {
                editor.off('paste', handler);
                editor.off('drop', handler);
            };
        },
    };
}
